<template>
	<div class="flex flex-wrap">
		<HeroSection>
			<TwoColumns
				first-column-width="w-full lg:w-3/5"
				second-column-width="w-full lg:w-2/5"
				second-column-class="px-5 pb-5 lg:pl-0"
				column-gap="md:space-y-8 lg:space-y-0 lg:space-x-5"
			>
				<template #first>
					<div class="w-full">
						<div
							class="flex h-full w-full items-center rounded-none bg-gray-100 p-2 md:p-4 lg:rounded-bl-md lg:rounded-tl-md"
						>
							<CarbarImage
								v-if="
									product.largeImages &&
									product.largeImages.length
								"
								:image="product.largeImages[0].file_path"
								:alt-text="
									product.largeImages[0].alt_text ??
									`${product.year} ${product.make} ${product.model} image`
								"
								class="pointer-events-none w-full"
								style="width: 100%; height: auto"
							/>
							<CarbarImage
								v-if="
									!product.largeImages ||
									!product.largeImages.length
								"
								image="img/product-catalog/img-comingsoon-xl.webp"
								alt-text="Coming soon"
							/>
						</div>
					</div>
				</template>
				<template #second>
					<div class="py-6">
						<BreadcrumbNavigation
							:crumbs="[
								{
									title: 'Home',
									url: '/',
								},
								{
									title: 'Cars',
									url: '/cars/subscribe',
								},
								{
									title: 'Subscribe',
									url: '/cars/subscribe',
								},
								{
									title: `${product.year} ${product.make} ${product.model}`,
								},
							]"
						/>
					</div>
					<div class="w-full">
						<div class="flex w-full flex-col pl-0">
							<div class="flex justify-between">
								<div class="flex flex-col space-y-2">
									<VehicleDetailsLocations
										:location="product.location"
										:available-locations="
											product.available_locations
										"
									/>
									<h1
										class="mb-0 truncate font-body text-2xl font-semibold uppercase"
										:data-stock-number="
											product.stock_number
										"
									>
										{{ product.year }}
										{{ product.make }}
										{{ product.model }}
									</h1>
									<div>
										<div
											class="text-base uppercase text-gray-600"
										>
											<span>
												{{ product.badge ?? '' }}
											</span>
										</div>
										<div
											class="flex space-x-3 text-base text-gray-600 md:space-x-4"
										>
											<span
												v-if="
													product.transmission ||
													product.transmission_type
												"
											>
												{{
													product.transmission_type ??
													(`${product.transmission}`
														.toLowerCase()
														.includes('manual')
														? 'Manual'
														: 'Automatic')
												}}
											</span>
											<span v-if="product.body_type">
												{{ product.body_type }}
											</span>
											<span
												v-if="
													product.fuel_type ||
													product.fuel
												"
											>
												{{
													product.fuel ??
													product.fuel_type
												}}
											</span>
										</div>
									</div>
								</div>
							</div>
							<div class="mt-5">
								<CarbarButton
									class="w-full"
									:size="6"
									:min-width="`min-w-full`"
									:disabled="true"
								>
									No longer available
								</CarbarButton>
							</div>
						</div>
					</div>
				</template>
			</TwoColumns>
		</HeroSection>
		<ContainedSection :has-padding="false">
			<SimilarVehicles
				:product="product"
				:limit="6"
				:show-all="true"
				:show-slide-arrows="false"
				class="mt-8"
			/>
		</ContainedSection>
	</div>
</template>

<script setup>
import CarbarButton from '@/components/buttons/CarbarButton.vue'
import CarbarImage from '@/components/CarbarImage.vue'
import HeroSection from '@/components/sections/HeroSection.vue'
import TwoColumns from '@/components/sections/TwoColumns.vue'
import ContainedSection from '@/components/sections/ContainedSection.vue'
import SimilarVehicles from '@/components/vehicle-details/SimilarVehicles.vue'
import VehicleDetailsLocations from '@/components/vehicle-details/VehicleDetailsLocations.vue'
import BreadcrumbNavigation from '@/components/breadcrumbs/BreadcrumbNavigation.vue'

const props = defineProps({
	product: {
		type: Object,
		required: true,
	},
})
</script>
